import { memo } from 'react';

import { useMobileMediaQuery } from '@/shared/lib/hooks';

import { PatternFilterAsDrawer } from '../pattern-filter-as-drawer/pattern-filter-as-drawer';
import { PatternFilterButton } from '../pattern-filter-button/pattern-filter-button';

export const PatternFilter = memo(() => {
    const isMobile = useMobileMediaQuery();

    if (isMobile) return <PatternFilterAsDrawer />;

    return <PatternFilterButton />;
});

PatternFilter.displayName = 'PatternFilter';
